import React, { useState, useEffect } from "react";
import { API, getToken } from "@/lib/api";
import { Loader2, ImageOff } from "lucide-react";

// Fetches a protected image (e.g. KYC document) with the auth header and shows
// it via an object URL. `path` is the API path after /api, e.g. /verification-doc/{id}.
export function AuthedImage({ path, alt = "", className = "" }) {
  const [url, setUrl] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    let revoked;
    let cancelled = false;
    (async () => {
      try {
        const res = await fetch(`${API}${path}`, { headers: { Authorization: `Bearer ${getToken()}` } });
        if (!res.ok) throw new Error("failed");
        const blob = await res.blob();
        if (cancelled) return;
        revoked = URL.createObjectURL(blob);
        setUrl(revoked);
      } catch {
        if (!cancelled) setError(true);
      }
    })();
    return () => { cancelled = true; if (revoked) URL.revokeObjectURL(revoked); };
  }, [path]);

  if (error) return <div className={`flex items-center justify-center bg-secondary ${className}`}><ImageOff className="h-6 w-6 text-muted-foreground" /></div>;
  if (!url) return <div className={`flex items-center justify-center bg-secondary ${className}`}><Loader2 className="h-5 w-5 animate-spin text-muted-foreground" /></div>;
  return <img src={url} alt={alt} className={className} />;
}
